import { ReactNode } from 'react'

import InformationToolTip from '../../../../components/elements/information-tooltip'
import { LocaleKeys } from '../../../../locale/translation-types'

export enum IDTypeEnum {
  IDENTITY_CARD = 'IDENTITY_CARD',
  PASSPORT = 'PASSPORT'
}

type IDMappingType = {
  title: LocaleKeys
  information: ReactNode
}

export const IDTypeEnumMapping: Record<IDTypeEnum, IDMappingType> = {
  [IDTypeEnum.IDENTITY_CARD]: {
    title: 'staff.personal.space.identity.card',
    information: (
      <InformationToolTip variant="secondary" size="small">
        <div className="flex gap-2 mobile:flex-col">
          <img src="/id.png" alt="ID card" height={250} width={250} className="rounded" />
          <img
            src="/id-with-comments.jpeg"
            alt="ID card"
            height={250}
            width={250}
            className="rounded"
          />
        </div>
      </InformationToolTip>
    )
  },
  [IDTypeEnum.PASSPORT]: {
    title: 'staff.personal.space.passport',
    information: (
      <InformationToolTip variant="secondary" size="small">
        <div className="flex gap-2 mobile:flex-col">
          <img
            src="/passport.png"
            alt="ID card"
            height={250}
            width={250}
            className="rounded object-cover"
          />
          <img
            src="/passport-with-comments.jpeg"
            alt="ID card"
            height={250}
            width={250}
            className="rounded object-cover"
          />
        </div>
      </InformationToolTip>
    )
  }
}
